// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".terms__see-more-less{margin-top:20px}.terms .terms__top-brokers{margin:34px 0}", ""]);
// Exports
module.exports = exports;
